import * as React from 'react';

// Icon type enum for stronger typing
export enum IconType {
    WEAVER = 'weaver',
    WEAVER_X = 'weaver-x',
    SUBTEXT = 'subtext',
}

// Custom icon components using SVG files from public/images/icons
const WeaverIcon = React.forwardRef<HTMLObjectElement, { style?: React.CSSProperties; className?: string }>((props, ref) => {
    return React.createElement('object', {
        data: '/images/icons/weaver-icon.svg',
        type: 'image/svg+xml',
        style: { width: 24, height: 24, pointerEvents: 'none', ...props.style },
        className: props.className,
        ref: ref
    });
});

const WeaverXIcon = React.forwardRef<HTMLObjectElement, { style?: React.CSSProperties; className?: string }>((props, ref) => {
    return React.createElement('object', {
        data: '/images/icons/weaver-x-icon.svg',
        type: 'image/svg+xml',
        style: { width: 24, height: 24, pointerEvents: 'none', ...props.style },
        className: props.className,
        ref: ref
    });
});

const SubtextIcon = React.forwardRef<HTMLObjectElement, { style?: React.CSSProperties; className?: string }>((props, ref) => {
    return React.createElement('object', {
        data: '/images/icons/subtext-icon.svg',
        type: 'image/svg+xml',
        style: { width: 24, height: 24, pointerEvents: 'none', ...props.style },
        className: props.className,
        ref: ref
    });
});

// Icon mapping for custom icons
export const iconComponents: Record<IconType, React.ComponentType<any>> = {
    [IconType.WEAVER]: WeaverIcon,
    [IconType.WEAVER_X]: WeaverXIcon,
    [IconType.SUBTEXT]: SubtextIcon,
};

/**
 * Get the icon component for a given icon name
 * @param iconName - The name of the icon from GameConfig
 * @returns The React component for the icon, or null if not found
 */
export function getIconComponent(iconName: IconType): React.ComponentType<any> | null {
    return iconComponents[iconName] || null;
} 